Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') {
      cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var formatString = (format || this.money_format);
      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
              return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }
      return formatString.replace(placeholderRegex, value);
      };

     var Shopify = Shopify || {};
     Shopify.money_format = upcartMoneyFormat;

/* end of price format   */

function savePrice(variantId){
  const formattedPrices = window.SubscriptionWidgetConfig.formattedPrices;
   if (formattedPrices && formattedPrices[variantId]) {
      const unitPrice = formattedPrices[variantId].unit;
      const discountedPrice = formattedPrices[variantId].discounted;
      const custom_compare_price = $('.product-form__input input:checked').data('compare-price');
      var numb1 = unitPrice.match(/\d/g);
      numb1 = numb1.join("");
      // console.log(numb1);
      let numb2 = discountedPrice.match(/\d/g);
      numb2 = numb2.join("");
      let differenc =   Number(numb1) - Number(numb2);
      // let price = differenc * 100;
      //  console.log(typeof price);
      let format_price =  Shopify.formatMoney(differenc);
      let format_comprice =  Shopify.formatMoney(custom_compare_price);
      const intervalId = setInterval(function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        let save_text = $('body').data('save');
        if (rechargeWidget && rechargeWidget.shadowRoot) {
            const shadowRoot = rechargeWidget.shadowRoot;
            const discountedPriceElement = shadowRoot.querySelector('.rc-purchase-option__subscription');
            const price_color = shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price:last-child');
            const compare_price = shadowRoot.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
            const label_container = shadowRoot.querySelector('.rc-selection__onetime .rc-purchase-option__label');
            const label_container2 = shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__label');
            compare_price.setAttribute('part',"custom-onetime-price");
            label_container.setAttribute('part',"custom-label-option");
            label_container2.setAttribute('part',"custom-label-option");
            if (discountedPriceElement) {
             let customPriceDiv = $(discountedPriceElement).find('.custom-price');
             let customComPrice = $(compare_price).find('.custom-compair-price');
              if (customPriceDiv.length === 0) {
                   $(discountedPriceElement).append(`<span class="custom-price rc-purchase-option__badge" part="custom-price">${save_text} ${format_price}</span>`);
                } else {
                  customPriceDiv.text(`${save_text} ${format_price}`);
                }
                 /* compare price span */
              if(custom_compare_price){
                if (customComPrice.length === 0 ) {
                   $(compare_price).append(`<span class="custom-compair-price strike-through" part="custom-compair-price">${format_comprice}</span>`);
                } else {
                  customComPrice.text(`${format_comprice}`);
                }
              }else{
                 customComPrice.remove();
              }
                
               clearInterval(intervalId);
              // $(discountedPriceElement).prepend(`<div class='custom-price'><span style="color:#091437; font-size:18px; font-weight:600;">SAVE : ${format_price}</span></div>`);
            } else {
                console.log("Discounted price not found.");
            }
        }
      }, 100);

  }
}

$(document).ready(function(){
  const variantId = $('.product-form__input input:checked').data('variant-id');
  savePrice(variantId);
});
 $('.product-form__input input').change(function(){
   let variant_id = $(this).data('variant-id');
   savePrice(variant_id);
 });
 
  const intervalIds = setInterval(function () {
    const rechargeWidget = document.querySelector('recharge-subscription-widget');
    if (rechargeWidget && rechargeWidget.shadowRoot) {
            const shadowRoot = rechargeWidget.shadowRoot;
            let shadow_inner = shadowRoot.querySelector('rc-selling-plans').shadowRoot.querySelector('fieldset');
            let stylesheet = document.createElement('link');
            stylesheet.rel = 'stylesheet';
            stylesheet.type = 'text/css';
            stylesheet.href = '//store.tipaw.com/cdn/shop/t/8/assets/custom.css?v=145938544356813883141739444387';
            let stylesheet_inner = document.createElement('link');
            stylesheet_inner.rel = 'stylesheet';
            stylesheet_inner.type = 'text/css';
            stylesheet_inner.href = '//store.tipaw.com/cdn/shop/t/8/assets/custom.css?v=145938544356813883141739444387';
            shadowRoot.appendChild(stylesheet);
            shadow_inner.appendChild(stylesheet_inner);
            clearInterval(intervalIds);
        }
      }, 100);


// on change widget css

setInterval(() => {
    const changeRechargeWidget = document.querySelector('recharge-subscription-widget');
    const changeShadowRoot = changeRechargeWidget.shadowRoot;
    const rechargeSubTime = changeShadowRoot.querySelector('.rc-purchase-option__subscription input[value="subscription"]');
    $(rechargeSubTime).change(function () {
        const innerRechargeWidget = document.querySelector('recharge-subscription-widget');
        const innerShadowRoot = innerRechargeWidget.shadowRoot;
        const hrefToRemove = "//store.tipaw.com/cdn/shop/t/8/assets/custom.css?v=145938544356813883141739444387"; 
        let changeShadow_inner1 = changeShadowRoot.querySelector('rc-selling-plans').shadowRoot;
        const linkElement = [...changeShadow_inner1.querySelectorAll('link[rel="stylesheet"]')].find(link => link.href.includes(hrefToRemove));
        if (linkElement) {
          linkElement.remove();
         } 
          let changeShadow_inner = innerShadowRoot.querySelector('rc-selling-plans').shadowRoot.querySelector('fieldset');
          let newStylesheet = document.createElement("link");
          newStylesheet.rel = "stylesheet";
          newStylesheet.type = 'text/css';
          newStylesheet.href = "//store.tipaw.com/cdn/shop/t/8/assets/custom.css?v=145938544356813883141739444387";
          changeShadow_inner.append(newStylesheet);
        });
    
}, 1000);
// end css

// load variant price

  function changePriceVar(){
     const setId = setInterval(function () {
     const recharge_widget = document.querySelector('recharge-subscription-widget');
      if (recharge_widget && recharge_widget.shadowRoot) {
            const shadow_root = recharge_widget.shadowRoot;
            const onetimePurcahse = shadow_root.querySelector('.rc-selection__onetime');
            const subsPurcahse = shadow_root.querySelector('.rc-purchase-option__subscription');
            let subscriptionPrice = subsPurcahse.querySelector('.rc-purchase-option__prices');
            let subscriptionInput = subsPurcahse.querySelector('.rc-purchase-option__input');
            if(subscriptionInput.checked){
                 $('.one_time_price').hide();
                 $('.subscription_price').show();
                 $('.product .price__regular').hide();
                 $('.product .price__sale').show();
                 $('.product .price__badge-sale').css('display','inline-block');
             }else{
                 $('.one_time_price').show();
                 $('.subscription_price').hide();
                 $('.product .price__regular').show();
                 $('.product .price__sale').hide();
                 $('.product .price__badge-sale').hide();
             }
           clearInterval(setId);
      }
     
   }, 100);

  }

// end variant price

 /* selected Price */
  function changePrice(){
     const setId = setInterval(function () {
     const recharge_widget = document.querySelector('recharge-subscription-widget');
      if (recharge_widget && recharge_widget.shadowRoot) {
            const shadow_root = recharge_widget.shadowRoot;
            const onetimePurcahse = shadow_root.querySelector('.rc-selection__onetime');
            const subsPurcahse = shadow_root.querySelector('.rc-purchase-option__subscription');
            let subscriptionPrice = subsPurcahse.querySelector('.rc-purchase-option__prices');
            let subscriptionInput = subsPurcahse.querySelector('.rc-purchase-option__input');
            let subs_stike_price = subscriptionPrice.querySelector('.strike-through').innerText;
            let subs_stike_original = subscriptionPrice.querySelector('.rc-price:last-child').innerText;
            if(subscriptionInput.checked){
             $('.product .price__sale .price-item--sale').text(subs_stike_original);
             $('.product .price__sale .price-item--regular').text(subs_stike_price);
            }
           clearInterval(setId);
      }
     
   }, 100);

  }
 /* end selected Price */

$(document).ready(function(){
  const variantId = $('.product-form__input input:checked').data('variant-id');
  savePrice(variantId);
  const setId = setInterval(function () {
    const recharge_widget = document.querySelector('recharge-subscription-widget');
    const shadow_root = recharge_widget.shadowRoot;
    const subsPurcahse = shadow_root.querySelector('.rc-purchase-option__subscription');
    const oneTimePurcahse = shadow_root.querySelector('.rc-selection__onetime');
    let subscriptionPrice = subsPurcahse.querySelector('.rc-purchase-option__prices');
    subscriptionPrice.querySelector('.rc-price:last-child .visually-hidden').remove();
   
     clearInterval(setId);
     subsPurcahse.addEventListener('change',function(){
        $('.product .price__sale').css('display','block');
        $('.product .price__badge-sale').css('display','inline-block');
        $('.product .price__regular').css('display','none');
         $('.one_time_price').hide();
         $('.subscription_price').show();
     changePrice();
    })
    oneTimePurcahse.addEventListener('change',function(){
     let oneTimePrice = oneTimePurcahse.querySelector('.rc-price').innerText;
     let onetime_compare_price = $('.product-form__input input:checked').data('compare-price');
      if(!onetime_compare_price){
        $('.product .price__sale').css('display','none');
        $('.product .price__badge-sale').css('display','none');
        $('.product .price__regular').css('display','block');
      }
      let oneTimeComPrice = oneTimePurcahse.querySelector('.custom-compair-price').innerText;
      if(oneTimeComPrice){
       $('.product .price__sale .price-item--regular').text(oneTimeComPrice);
       }
       $('.product .price__sale .price-item--sale').text(oneTimePrice);
     
       $('.one_time_price').show();
       $('.subscription_price').hide();
      
    });

    $('.product-form__input input').change(function(event){
     let variant_id = $(this).data('variant-id');
     savePrice(variant_id);
     setTimeout(function(){
          changePrice();
     },100);
       let input_field_oneTime = oneTimePurcahse.querySelector('.rc-purchase-option__input').checked;
       let input_field_sub = subsPurcahse.querySelector('.rc-purchase-option__input').checked;
       if(input_field_oneTime == true){
          let variant_price = $(this).data('price');
          let variant_comprice = $(this).data('compare-price');
          let format_price =  Shopify.formatMoney(variant_price);
          let format_price_com =  Shopify.formatMoney(variant_comprice);
         if(variant_comprice){
           $('.product .price__sale').css('display','block');
           $('.product .price__badge-sale').css('display','inline-block');
           $('.product .price__regular').css('display','none');
           $('.product .price-item--sale').text(format_price);
          $('.product .price__sale .price-item--regular').text(format_price_com);
         }else{
            $('.product .price__sale').css('display','none');
           $('.product .price__badge-sale').css('display','none');
           $('.product .price__regular').css('display','block');
           $('.product .price__regular .price-item--regular').text(format_price);
         }
         
      }
      if(input_field_sub == true ){
         let variant_price = $(this).data('price');
          let variant_comprice = $(this).data('compare-price');
          let format_price =  Shopify.formatMoney(variant_price);
          let format_price_com =  Shopify.formatMoney(variant_comprice);
         if(variant_comprice){
           $('.product .price__sale').css('display','block');
            $('.product .price__badge-sale').css('display','inline-block');
           $('.product .price__regular').css('display','none');
           $('.product .price-item--sale').text(format_price);
           $('.product .price__sale .price-item--regular').text(format_price_com);
         }
      }
     
 });
},100);
   // load call
  changePrice();
  changePriceVar()
  
});


$(document).ready(function () {
    $('.card-tabs-container').each(function () {
    const section = $(this);
      console.log('section', section)
      const tabs = section.find('.tabs-items');
      const cards = section.find('.card-container');

      function showTab(targetTab) {
        const tabId = targetTab.attr('data-tab');
        const tabColor = targetTab.attr('data-color');
        section.removeClass(function(index, className) {
        return (className || '').split(' ').filter(c => c.startsWith('color-scheme')).join(' ');
        });
        tabs.removeClass('current');
        cards.removeClass('current');

        targetTab.addClass('current');
        section.addClass(tabColor);
        section.find('#' + tabId).addClass('current');
      }

      tabs.on('click', function () {
        showTab($(this));
      });

    section.find('.next-arrow').on('click', function () {
        const current = tabs.filter('.current');
        const next = current.next('.tabs-items');

        if (next.length > 0) {
          showTab(next);
        }
        // else do nothing (we're already at the last tab)
      });

      section.find('.prev-arrow').on('click', function () {
        const current = tabs.filter('.current');
        const prev = current.prev('.tabs-items');

        if (prev.length > 0) {
          showTab(prev);
        }
        // else do nothing (we're already at the first tab)
      });
    });
  });


// video slider
$(document).ready(function() {
   $(document).on('click', '.video-control-1', function() {
    let video = $(this).closest('.video-main').find('video').get(0);
    let action = $(this).attr('data-action');
    if (!video) return;
    if (action === 'play') {
      video.pause();
      $(this).attr('data-action', 'pause');
    } else {
       video.play();
      $(this).attr('data-action', 'play');
    }
  });

  // Mute/Unmute
  $(document).on('click', '.video-control-2', function() {
  let btn = $(this);
  let currentVideo = btn.closest('.video-main').find('video').get(0);
  let currentCard = btn.closest('.card-inner-video').find('.slider-card__info--video');
   $('.card-inner-video').find('.slider-card__info--video').removeClass('slide-info');
  let currentAction = btn.attr('data-action');

  if (!currentVideo) return;

  if (currentAction === 'mute') {
    $('.custom-videos-container video').each(function() {
      this.muted = true;
    });

    $('.video-control-2').attr('data-action', 'mute');
    currentVideo.muted = false;
    btn.attr('data-action', 'unmute');
    currentCard.addClass('slide-info');
  } else {
    currentVideo.muted = true;
    btn.attr('data-action', 'mute');
    currentCard.removeClass('slide-info')
  }
});

});




$(document).ready(function () {
  const tabs = $('.section-tabs-container .tabs-items');
  let currentTab = $('.section-tabs-container .tabs-items.current')[0];

  function updateTab(newTab) {
    const tab_id = $(newTab).attr('data-class');

    tabs.removeClass('current');
    $('.content-for-layout .shopify-section div').removeClass('current');

    $(newTab).addClass('current');
    $('.' + tab_id).addClass('current');

    currentTab = newTab;
  }

  // Click on tab
  tabs.on('click', function () {
    updateTab(this);
  });

  $('.section-tabs-container .next-arrow').on('click', function () {
    let allTabs = tabs.get();
    let currentIndex = allTabs.indexOf(currentTab);
    if (currentIndex < allTabs.length - 1) {
      updateTab(allTabs[currentIndex + 1]);
    }
  });

  $('.section-tabs-container .prev-arrow').on('click', function () {
    let allTabs = tabs.get();
    let currentIndex = allTabs.indexOf(currentTab);
    if (currentIndex > 0) {
      updateTab(allTabs[currentIndex - 1]);
    }
  });

// count bar
  // Counting 2 days from now
const countDownDateTime = new Date().getTime() + 7200000;
const hoursValue = document.querySelector("#hours");
const minutesValue = document.querySelector("#minutes");
const secondsValue = document.querySelector("#seconds");
// Run this function every 1000 ms or 1 second
let x = setInterval(function () {
  const dateTimeNow = new Date().getTime();
  let difference = countDownDateTime - dateTimeNow;
  hoursValue.innerHTML = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  minutesValue.innerHTML = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  secondsValue.innerHTML = Math.floor((difference % (1000 * 60)) / 1000);
  let hour =  Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let mint = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  let second = Math.floor((difference % (1000 * 60)) / 1000);
  let deal_end = $('.deal-end-notify strong').text(`${hour}:${mint}:${second}`);
  if (difference < 0) {
  clearInterval(x);
  }
}, 100);



  
});
